import { render, staticRenderFns } from "./FMItemCard.vue?vue&type=template&id=be06411c&scoped=true"
import script from "./FMItemCard.vue?vue&type=script&lang=js"
export * from "./FMItemCard.vue?vue&type=script&lang=js"
import style0 from "./FMItemCard.vue?vue&type=style&index=0&id=be06411c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be06411c",
  null
  
)

export default component.exports